import { AVATAR_KEYS, type AvatarKey } from "@al-life/types";
import fox from "@/assets/avatars/fox.svg";
import cat from "@/assets/avatars/cat.svg";
import panda from "@/assets/avatars/panda.svg";
import rabbit from "@/assets/avatars/rabbit.svg";
import bear from "@/assets/avatars/bear.svg";
import penguin from "@/assets/avatars/penguin.svg";
import owl from "@/assets/avatars/owl.svg";
import koala from "@/assets/avatars/koala.svg";
import frog from "@/assets/avatars/frog.svg";
import lion from "@/assets/avatars/lion.svg";
import dog from "@/assets/avatars/dog.svg";
import hamster from "@/assets/avatars/hamster.svg";

/**
 * Maps each avatar key to its bundled SVG URL. These are static assets shipped
 * with the app — no per-user image storage. Adding a new avatar = drop an SVG
 * in assets/avatars, add its key to AVATAR_KEYS (shared types), and wire it here.
 */
export const AVATAR_SRC: Record<AvatarKey, string> = {
  fox,
  cat,
  panda,
  rabbit,
  bear,
  penguin,
  owl,
  koala,
  frog,
  lion,
  dog,
  hamster,
};

/** Human-friendly labels for the picker / alt text. */
export const AVATAR_LABELS: Record<AvatarKey, string> = {
  fox: "Fox",
  cat: "Cat",
  panda: "Panda",
  rabbit: "Rabbit",
  bear: "Bear",
  penguin: "Penguin",
  owl: "Owl",
  koala: "Koala",
  frog: "Frog",
  lion: "Lion",
  dog: "Dog",
  hamster: "Hamster",
};

export const ALL_AVATARS: AvatarKey[] = [...AVATAR_KEYS];
